import { Button } from '@vadiun/react-components';
import PageContainer from 'layout/components/PageContainer';
import PageHeader from 'layout/components/PageHeader';
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import CreateEditDiscountForm from '../components/create-edit-discount-form/CreateEditDiscountForm';
import { useDiscounts } from '../hook/useDiscounts';
import { Loading } from 'shared/components';
import {
  DiscountFormValues,
  PayLoadEditDiscount,
  transformDiscountToFormValues
} from '../models/discountModel';
import moment from 'moment';

const DiscountEditPage = () => {
  const history = useHistory();

  const {
    discounts,
    discount,
    loadingDiscount,
    errorDiscount,
    editDiscount,
    getAllDiscounts,
    loadingAllDiscounts,
    allDiscountsData
  } = useDiscounts();

  const [discountFormValues, setDiscountFormValues] =
    useState<DiscountFormValues>({} as DiscountFormValues);

  const handleCancel = () => {
    history.push('/main/inventories/discounts');
  };

  const discountEdit = async (values: any) => {
    const originalFromDate = discountFormValues.from_date;
    const originalEndDate = discountFormValues.end_date;
    const fromDateChanged = !moment(values.from_date).isSame(
      moment(originalFromDate)
    );
    const endDateChanged = !moment(values.end_date).isSame(
      moment(originalEndDate)
    );
    const payload: PayLoadEditDiscount = {
      id: discount!.id,
      ...values,
      from_date: fromDateChanged ? values.from_date : moment(originalFromDate),

      end_date: endDateChanged ? values.end_date : moment(originalEndDate)
    };
    await editDiscount(payload);
    handleCancel();
  };

  useEffect(() => {
    if (discount) {
      setDiscountFormValues(transformDiscountToFormValues(discount));
      getAllDiscounts(null, null, null, null, null, null);
    }
  }, [discount]);

  if (
    loadingDiscount ||
    !discountFormValues.name || loadingAllDiscounts ||
    !(allDiscountsData && (allDiscountsData as any).length > 0)
  ) {
    return <Loading />;
  }

  if (errorDiscount) {
    handleCancel();
  }

  return (
    <>
      <PageHeader
        title="Descuento"
        subArea={'Editar descuento'}
        toolbar={
          <Link to={'/main/inventories/discounts'} className="inline-flex items-center">
            <Button variant="light">Volver</Button>
          </Link>
        }
      />
      <PageContainer>
        <div className="flex w-full justify-center">
          <CreateEditDiscountForm
            onSubmit={discountEdit}
            onCancel={handleCancel}
            isEditing
            initialValues={discountFormValues}
            existingDiscounts={(allDiscountsData as any).filter((d) => d.id !== discount?.id)}
          />
        </div>
      </PageContainer>
    </>
  );
};

export default DiscountEditPage;
